import { render, staticRenderFns } from "./AvenantPropertyManager.vue?vue&type=template&id=00bea7e4"
import script from "./AvenantPropertyManager.vue?vue&type=script&lang=ts"
export * from "./AvenantPropertyManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports